import { render, staticRenderFns } from "./goc-task.vue?vue&type=template&id=6d7b6634"
import script from "./goc-task.vue?vue&type=script&lang=js"
export * from "./goc-task.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d7b6634')) {
      api.createRecord('6d7b6634', component.options)
    } else {
      api.reload('6d7b6634', component.options)
    }
    module.hot.accept("./goc-task.vue?vue&type=template&id=6d7b6634", function () {
      api.rerender('6d7b6634', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/research/curriculum-manage/components/goc-task.vue"
export default component.exports